import { render, staticRenderFns } from "./AIC_page.vue?vue&type=template&id=8c452162&scoped=true&"
import script from "./AIC_page.vue?vue&type=script&lang=js&"
export * from "./AIC_page.vue?vue&type=script&lang=js&"
import style0 from "./AIC_page.vue?vue&type=style&index=0&id=8c452162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c452162",
  null
  
)

export default component.exports